class ModalButton extends HTMLElement {
    constructor() {
        super(); // Llama al constructor de HTMLElement
    }

    connectedCallback() {
        this.load();
        this.events();
    }

    load = () => {
        // console.log(this);
    };

    events = () => {
        this.addEventListener("click", () => {
            const modal = document.querySelector(
                "dialog[data-modal=" +
                    (this.getAttribute("data-modal") ?? "customModal") +
                    "]"
            );

            if (modal) {
                const url = this.getAttribute("data-url");
                modal?.showModal();
                if (url) {
                    const form = modal.querySelector("form[name=form]");
                    if (form) {
                        form.setAttribute("action", url);
                    }
                }
            } else {
                console.log("modal no encontrado");
            }
        });
    };
}

customElements.define("modal-button", ModalButton);
